import React from 'react';

let iconPhone = require('assets/images/phone.png');
let iconPhoneLg = require('assets/images/phone-lg.png');

export default class HotLine extends React.Component {

  render() {
    return (
      <div className="hotline-wrap">
        {
          this.props.routerName == 'congDanTraCuu' ?
            <img src={iconPhoneLg} alt="iconPhoneLg" className="phone-ico"/>
          :
            <img src={iconPhone} alt="iconPhone" className="phone-ico"/>
        }
        <div className="hotline-content">
          <span className="hotline-number">0255 3824 185</span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/partials/HotLine.jsx